export enum PAYMENT_TYPE {
    ads ='2',
    package = '1',
    booking = '4',
    deposit = 'DEPOSIT',
    installment = 'INSTALLMENT'       
}